(function () {
  var ROOT_SELECTOR = ".stl-lp, .stl-contact-lp";
  var FORM_ZONE_SELECTOR = ".stl-lp-seo-visual__form-zone, .stl-contact-lp__form-zone";

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getScrollOffset() {
    var headerSection = document.querySelector(".stellar-header-shopify-section");
    var offset = 20;
    if (headerSection) {
      offset += headerSection.offsetHeight;
    } else {
      offset += 88;
    }
    return offset;
  }

  function scrollToTarget(target, behavior) {
    var top =
      target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior || "smooth",
    });
  }

  function resolveTarget(id, link) {
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }

    var root = link.closest(ROOT_SELECTOR);
    if (!root) return null;

    return (
      root.querySelector(FORM_ZONE_SELECTOR + "[id]") ||
      document.querySelector(FORM_ZONE_SELECTOR + "[id]") ||
      document.querySelector(FORM_ZONE_SELECTOR)
    );
  }

  function bindAnchor(link) {
    if (link.dataset.stlAnchorBound === "true") return;

    var href = link.getAttribute("href");
    if (!href || href.charAt(0) !== "#") return;

    var id = "";
    if (href.length > 1) {
      try {
        id = decodeURIComponent(href.slice(1));
      } catch (e) {
        return;
      }
    }

    link.dataset.stlAnchorBound = "true";
    link.addEventListener("click", function (event) {
      var target = resolveTarget(id, link);
      if (!target) return;

      event.preventDefault();
      scrollToTarget(target, prefersReducedMotion() ? "auto" : "smooth");

      var hash = target.id ? "#" + target.id : href;
      if (history.replaceState) {
        history.replaceState(null, "", hash);
      } else {
        window.location.hash = hash;
      }
    });
  }

  function initRoot(root) {
    if (!root) return;
    root.querySelectorAll('a[href^="#"]').forEach(bindAnchor);
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
